import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ThemeColor } from '../helpers';

const iconsByType: Record<ThemeColor, string> = {
  default: 'info',
  info: 'help_circle',
  primary: 'info',
  success: 'check_circle',
  warning: 'warning',
  danger: 'error',
};

const classesByType: Record<ThemeColor, string[]> = {
  default: ['bg-gray-200', 'text-black'],
  info: ['bg-cyan-500', 'text-white'],
  danger: ['bg-red-500', 'text-white'],
  primary: ['bg-blue-500', 'text-white'],
  success: ['bg-green-500', 'text-white'],
  warning: ['bg-yellow-500', 'text-white'],
};

@Component({
  selector: 'app-pan-inline-alert',
  templateUrl: './pan-inline-alert.component.html',
  styleUrl: './pan-inline-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PanInlineAlertComponent {
  public label = input<string>('');
  public type = input<ThemeColor>('default');
  public icon = input<string>('');
  public assertive = input<boolean>(false);

  public classes = computed(() => classesByType[this.type()]);
  public usedIcon = computed(() => this.icon() || iconsByType[this.type()]);
  public role = computed(() => (this.assertive() || this.type() === 'danger' ? 'alert' : 'status'));
  public ariaLive = computed(() => (this.role() === 'alert' ? 'assertive' : 'polite'));
}
